import { SOLUTION_TYPE, SolutionType } from '../../../constants/user-info/solutionType';
import { userRoles, UserRoleTypes } from '../../../constants/userRoles';
import { pluralizeString } from '../../stringUtils/pluralizeString/pluralizeString';
import { CaseType, textTransform } from '../../stringUtils/textTransform/textTransform';

type UserInfo = {
  solution?: SolutionType | null;
};

export type FormatConfig = {
  case?: CaseType;
  pluralize?: boolean;
};

// role should be in capital case and without pluralization by default
const BASE_ROLE_MAPPINGS = {
  [userRoles.SUPERUSER]: 'Super Admin',
  [userRoles.ADMIN]: 'Entity Admin',
  [userRoles.AGENT]: 'Coach',
  [userRoles.CUSTOMER]: 'User',
  [userRoles.FOOD_ADMIN]: 'Food Admin',
} as const;

const SCAN_IQ_ROLE_MAPPINGS = {
  [userRoles.SUPERUSER]: 'Super Admin',
  [userRoles.ADMIN]: 'Entity Admin',
  [userRoles.AGENT]: 'Staff Member',
  [userRoles.CUSTOMER]: 'User',
  [userRoles.FOOD_ADMIN]: 'Food Admin',
} as const;

const CHALLENGE_ROLE_MAPPINGS = {
  [userRoles.SUPERUSER]: 'Super Admin',
  [userRoles.ADMIN]: 'Entity Admin',
  [userRoles.AGENT]: 'Staff Member',
  [userRoles.CUSTOMER]: 'User',
  [userRoles.FOOD_ADMIN]: 'Food Admin',
} as const;

const getRoleMapping = (
  userRole: UserRoleTypes,
  solution?: SolutionType | null,
): string => {
  switch (solution) {
    case SOLUTION_TYPE.SCAN_IQ:
      return SCAN_IQ_ROLE_MAPPINGS[userRole];
    case SOLUTION_TYPE.CHALLENGE:
      return CHALLENGE_ROLE_MAPPINGS[userRole];
    default:
      return BASE_ROLE_MAPPINGS[userRole];
  }
};

export const getHumanizeUserRole = (
  userRole: UserRoleTypes,
  userInfo?: UserInfo,
  /**
   * @description Format config for the role
   * @default  case: 'capital', pluralize: false
   */
  formatConfig?: FormatConfig,
): string => {
  const { solution } = userInfo ?? {};

  let role = getRoleMapping(userRole, solution);

  if (formatConfig?.pluralize) {
    role = pluralizeString(role);
  }

  if (formatConfig?.case) {
    role = textTransform(role, formatConfig.case);
  }

  return role;
};
